export default {
  namespaced: true,
  state: {
    showMenuModalFlag: false,
    selectedMenuItem: "",
    menuModalFlagOpenedFrom: "",
    clickedCategoryAnchorLink: "",
    stopHorizontalScrollAnchorLinks: false,
    stopHorizontalScrollAnchorLinksFilterClick: false,
  },
  getters: {},
  mutations: {
    updateNewMenuModalFlag(state, payload) {
      state.showMenuModalFlag = payload;
    },
    updateMenuModalFlagOpenedFrom(state, payload) {
      state.menuModalFlagOpenedFrom = payload;
    },
    updateClickedCategoryAnchorLink(state, payload) {
      state.clickedCategoryAnchorLink = payload;
    },
    updateSelectedMenuItem(state, payload) {
      state.selectedMenuItem = payload;
    },
    updateStopHorizontalScrollAnchorLinks(state, payload) {
      state.stopHorizontalScrollAnchorLinks = payload;
    },
    updateStopHorizontalScrollAnchorLinksFilterClick(state, payload) {
      state.stopHorizontalScrollAnchorLinksFilterClick = payload;
    },
  },
  actions: {},
};
